module.exports = __webpack_public_path__ + "img/game-development.bc9a5dca.svg";